import {
    BLOG_POST_CREATED,
    BLOG_POST_UPDATED,
    CLEAR_TEASERBOXES,
    FETCH_TEASERBOXES_FULFILLED,
    FETCH_TEASERBOXES_PENDING,
    FETCH_TEASERBOXES_REJECTED,
} from './action-types'

export interface ITeaserBoxState {
    failed: boolean;
    items: any[];
    loading: boolean;
    fetchHasBeenInitialized: boolean;
}

const initialState: ITeaserBoxState = {
    failed: false,
    items: [],
    loading: false,
    fetchHasBeenInitialized: false
};

export const teaserboxesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TEASERBOXES_PENDING:
            return {
                ...state,
                loading: true,
                fetchHasBeenInitialized: true,
            };

        case FETCH_TEASERBOXES_REJECTED:
            return {
                ...state,
                failed: true,
                loading: false,
            };

        case FETCH_TEASERBOXES_FULFILLED:
            return {
                ...state,
                loading: false,
                failed: false,
                items: action.payload.data,
            };

        case BLOG_POST_CREATED:
            return {
                ...state,
                items: state.items.map((item) => {
                    if (!!item.blog && item.blog.id === action.meta.item.blogId) {
                        return {
                            ...item,
                            blogPost: {
                                id: action.meta.item.id,
                                headline: action.meta.item.title,
                                title: action.meta.item.title,
                                image: action.meta.item.imageUrl,
                                url: action.meta.item.url,
                                publishDate: action.meta.item.date,
                                readTimeMinutes: action.meta.item.readTimeMinutes,
                            }
                        };
                    }
                    return item;
                })
            };

        case BLOG_POST_UPDATED:
            return {
                ...state,
                items: state.items.map((item) => {
                    if (item.blogPost?.id === action.meta.item.id) {
                        return {
                            ...item,
                            blogPost: {
                                ...item.blogPost,
                                headline: action.meta.item.title,
                                title: action.meta.item.title,
                                image: action.meta.item.imageUrl,
                                url: action.meta.item.url,
                            }
                        };
                    }
                    return item;
                })
            };

        case CLEAR_TEASERBOXES:
            return {
                ...initialState,
            };

        default:
            return state
    }
};

export default teaserboxesReducer
